import debounce from "../../../frontend/src/mixins/debounce";

export default debounce
